import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { PerfectScrollbarModule } from 'perfect-scrollbar-angular';
import { AdjustMenuPositionDirective } from 'src/app/Directives/adjustMenuPosition.directive';
import { TooltipDirective } from 'src/app/Directives/tooltip.directive';
import { SafePipe } from 'src/app/Pipes/safe.pipe';
import { CMD_ACTIONS, CMD_TARGETS, CmdRouterService } from 'src/app/services/cmd-router.service';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'ins-multiple-placemarks-menu',
  templateUrl: './multiple-placemarks-menu.component.html',
  styleUrls: ['./multiple-placemarks-menu.component.scss'],
  imports: [AdjustMenuPositionDirective, PerfectScrollbarModule, TooltipDirective, SafePipe]
})
export class MultiplePlacemarksMenuComponent implements OnInit {
  public multiplePlacemarks: any = [];
  public position: any = {x: 0, y: 0};
  public showMenu: boolean = false;

  constructor(private readonly mapService: MapService, private readonly cdr: ChangeDetectorRef, 
    private cmdRouterService: CmdRouterService) { }

  ngOnInit(): void {
    this.mapService.multiplePlacemarksChange.subscribe( (res: any) => {
      this.showMenu = false;
      this.multiplePlacemarks = res.multiplePlacemarks;
      this.position = res.position;
      requestAnimationFrame(() => this.showMenu = this.multiplePlacemarks.length > 0);
    });
  }

  public openPlacemark($event, marker) {
    this.cmdRouterService.sendActionCmd(CMD_TARGETS.MAP_MANAGER, CMD_ACTIONS.OPEN_PLAEMARK, {event: $event, marker: marker});
  }

  public openRightClickMenu($event, marker) {
    this.cmdRouterService.sendActionCmd(CMD_TARGETS.MAP_MANAGER, CMD_ACTIONS.OPEN_CONTEXT_MENU, {event: $event, marker: marker});
    $event.preventDefault();
  }

  public onMouseHover($event, marker) {
    $event.preventDefault();
    this.cmdRouterService.sendActionCmd(CMD_TARGETS.MAP_MANAGER, CMD_ACTIONS.MULTIPLE_PLACEMARK_MENU_ITEM_HOVER, {hover: true, event: $event, marker: marker});
  }

  public onMouseLeave($event, marker) {
    this.cmdRouterService.sendActionCmd(CMD_TARGETS.MAP_MANAGER, CMD_ACTIONS.MULTIPLE_PLACEMARK_MENU_ITEM_HOVER, {hover: false, event: $event, marker: marker});
  }

  public getToolTipConf(element: any, label: string): any {
    let toolTipConf = { text: '', position: { H: 'hLeft', V: 'vBottom' }, type: 'info' };
    if (element.offsetWidth < element.scrollWidth) {
      toolTipConf.text = label;
    }
    return toolTipConf;
  }
}
